import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import MonthlyRoster from 'app/containers/HumanResources/MonthlyRosterReport'

const MonthlyRosterPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.monthly_roster)}</PageTitle>
      <MonthlyRoster />
    </>
  )
}
const MonthlyRosterPage = memo(MonthlyRosterPageCpn, isEqual)

export default MonthlyRosterPage
